import axios from 'axios';
export const getSiteTaskList = (
  construct_id: number,
  site_process_id?: number,
  charge_user_id?: number,
  status?: number,
  alert_only?: boolean,
  include_child_site_process?: boolean,
  page?: number,
  display_limit?: number
) => {
  return axios
    .get(`/api/v1/task`, {
      params: {
        construct_id,
        site_process_id,
        charge_user_id,
        status,
        alert_only,
        include_child_site_process,
        page,
        display_limit
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getSiteTaskDetail = (siteTaskId: number) => {
  return axios
    .get(`/api/v1/task/${siteTaskId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createSiteTask = (
  site_process_id: number,
  site_task_name: string,
  charge_user_id?: number | null,
  planned_end_date?: string | null,
  detail?: string | null,
  order_category?: number | null,
  order_id?: number | null
) => {
  return axios
    .post(
      `/api/v1/task/create`,
      {
        site_process_id,
        site_task_name,
        charge_user_id,
        planned_end_date,
        detail,
        order_category,
        order_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteTask = (site_task_id: number) => {
  return axios
    .post(
      `/api/v1/task/delete`,
      {
        site_task_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateSiteTask = (
  site_task_id: number,
  site_process_id: number,
  site_task_name: string,
  status: number,
  charge_user_id?: number | null,
  planned_end_date?: string | null,
  detail?: string | null,
  order_category?: number | null,
  order_id?: number | null,
  actual_end_date?: string | null
) => {
  return axios
    .put(
      `/api/v1/task/update`,
      {
        site_task_id,
        site_process_id,
        site_task_name,
        status,
        charge_user_id,
        planned_end_date,
        detail,
        order_category,
        order_id,
        actual_end_date
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
